<a
    style="cursor: pointer"
    class="layout-config-button"
    style="background-color: var(--primary-color)"
    (click)="setVisible(true)">
    <i class="fa-solid fa-circle-half-stroke text-2xl text-white mr-2"></i>
</a>

<p-drawer
    [visible]="visible()"
    (visibleChange)="setVisible($event)"
    position="right"
    [transitionOptions]="'.2s cubic-bezier(0, 0, 0.2, 1)'"
    class="w-full sm:w-18rem">
    <div class="px-2">
        <h5>Theme</h5>
        <div class="theme-grid">
            @for (theme of themes; track theme.id) {
                <div
                    class="theme-swatch"
                    [class.theme-swatch--active]="selectedTheme() === theme.id"
                    (click)="setTheme(theme.id)"
                    role="button"
                    [title]="theme.label">
                    <div class="theme-swatch__preview">
                        <div
                            class="theme-swatch__sidebar"
                            [ngStyle]="{ 'background-color': theme.sidebar.bgColor }">
                            <span
                                class="theme-swatch__menu-line"
                                [ngStyle]="{ 'background-color': theme.sidebar.menuitemTextActiveColor }"></span>
                            <span
                                class="theme-swatch__menu-line"
                                [ngStyle]="{ 'background-color': theme.sidebar.menuitemTextColor }"
                                style="opacity: 0.35; width: 50%"></span>
                            <span
                                class="theme-swatch__menu-line"
                                [ngStyle]="{ 'background-color': theme.sidebar.menuitemTextColor }"
                                style="opacity: 0.35; width: 60%"></span>
                        </div>
                        <div
                            class="theme-swatch__content"
                            [ngStyle]="{ 'background-color': getContentBg(theme) }">
                            <span
                                class="theme-swatch__content-line"
                                [ngStyle]="{ 'background-color': getLineBg(theme) }"
                                style="width: 70%"></span>
                            <span
                                class="theme-swatch__content-line"
                                [ngStyle]="{ 'background-color': getLineBg(theme) }"
                                style="width: 90%"></span>
                            <span
                                class="theme-swatch__content-line"
                                [ngStyle]="{ 'background-color': getLineBg(theme) }"
                                style="width: 50%"></span>
                        </div>
                    </div>
                    <div class="theme-swatch__label">
                        {{ theme.label }}
                        @if (selectedTheme() === theme.id) {
                            <i class="pi pi-check"></i>
                        }
                    </div>
                </div>
            }
        </div>
        <hr />

        @if (!minimal) {
            <h5>Menu Type</h5>
            <div class="flex flex-wrap row-gap-3">
                <div class="flex align-items-center gap-2 w-6">
                    <p-radioButton
                        name="menuMode"
                        value="static"
                        [ngModel]="menuMode()"
                        (ngModelChange)="setMenuMode($event)"
                        inputId="mode1"></p-radioButton>
                    <label for="mode1">Static</label>
                </div>
                <div class="flex align-items-center gap-2 w-6 pl-2">
                    <p-radioButton
                        name="menuMode"
                        value="overlay"
                        [ngModel]="menuMode()"
                        (ngModelChange)="setMenuMode($event)"
                        inputId="mode2"></p-radioButton>
                    <label for="mode2">Overlay</label>
                </div>
                <div class="flex align-items-center gap-2 w-6">
                    <p-radioButton
                        name="menuMode"
                        value="slim"
                        [ngModel]="menuMode()"
                        (ngModelChange)="setMenuMode($event)"
                        inputId="mode3"></p-radioButton>
                    <label for="mode3">Slim</label>
                </div>
                <div class="flex align-items-center gap-2 w-6">
                    <p-radioButton
                        name="menuMode"
                        value="horizontal"
                        [ngModel]="menuMode()"
                        (ngModelChange)="setMenuMode($event)"
                        inputId="mode5"></p-radioButton>
                    <label for="mode4">Horizontal</label>
                </div>
            </div>
            <hr />
        }

        <h5>Scale</h5>
        <div class="flex align-items-center">
            <button
                icon="pi pi-minus"
                type="button"
                pButton
                (click)="decrementScale()"
                class="p-button-text p-button-rounded w-2rem h-2rem mr-2"
                [disabled]="scale() === scales[0]"></button>
            <div class="flex gap-3 align-items-center">
                @for (s of scales; track s) {
                    <i
                        class="pi pi-circle-fill"
                        [ngClass]="s === scale() ? 'text-primary' : 'text-color-secondary'"></i>
                }
            </div>
            <button
                icon="pi pi-plus"
                type="button"
                pButton
                (click)="incrementScale()"
                class="p-button-text p-button-rounded w-2rem h-2rem ml-2"
                [disabled]="scale() === scales[scales.length - 1]"></button>
        </div>

        <hr />

        <h5>Card Rounding</h5>
        <div class="flex flex-wrap row-gap-3">
            @for (opt of cardRadiusOptions; track opt.value) {
                <div class="flex align-items-center gap-2 w-6">
                    <p-radioButton
                        name="cardRadius"
                        [value]="opt.value"
                        [ngModel]="cardRadius()"
                        (ngModelChange)="setCardRadius($event)"
                        [inputId]="'radius-' + opt.value"></p-radioButton>
                    <label [for]="'radius-' + opt.value">{{ opt.label }}</label>
                </div>
            }
        </div>

        <hr />

        <button
            pButton
            pRipple
            label="Restore Defaults"
            icon="pi pi-refresh"
            (click)="restoreDefaults()"
            class="w-full"></button>
    </div>
</p-drawer>
